function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24,37v22h48V37H24z M70,57H26V39h44V57z"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "72,27 72,31 12,31 24,19 24,27 "
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "72,77 72,69 24,69 24,65 84,65 "
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38,48c0,2.7,1.1,5.2,2.9,7H28V41h12.9C39.1,42.8,38,45.3,38,48z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M68,41v14H55.1c1.8-1.8,2.9-4.3,2.9-7c0-2.7-1.1-5.2-2.9-7H68z"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "46,44 46,47 52,47 52,54 49,54 49,56 47,56 47,54 44,54 44,52 50,52 50,49 44,49 44,42 47,42 47,40 49,40 49,42   52,42 52,44 "
});

var SvgTrade = function SvgTrade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "12 24 72 48",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trade.2746d880.svg";
export { ForwardRef as ReactComponent };